<!-- <app-navbar></app-navbar> -->

<div
  class="card"
  style="
    padding: 20px; background-image: url('assets/img/school/bg.png');
    background-color: #005a63;
    background-size: 100px;
    background-attachment: fixed;
  "
>
  <div class="container" style="text-align: justify !important">
    <div class="row">
      <div class="col-md-12">
        <section class="blog-area gallery-section">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-2 text-center">
                <a routerLink="/folders" class="button">Back to Folders</a>
              </div>
              <div class="col-md-10 text-left">
                <h3
                  class="widget-title"
                  style="color: #ffffff; text-align: center"
                >
                  <!-- {{ selectedFolderName }} -->
                </h3>
              </div>
            </div>
            <hr />
            <div class="container">
              <div class="gallery-container">
                <div class="gallery">
                  <a
                    *ngFor="let image of ImageAlbums"
                    class="gallery__item"
                    href="{{ image.src }}"
                    [title]="image.alt"
                  >
                    <img
                      [src]="image.thumbnail"
                      [alt]="image.alt"
                      class="popup-btn"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
